// extracted by mini-css-extract-plugin
module.exports = {"common":"Button_common__1LQ6g","red":"Button_red__1sjHo Button_common__1LQ6g","redTransparent":"Button_redTransparent__1X3Pn Button_common__1LQ6g"};